import en from './en'
import zh from './zh_cn'

export default{
  en, zh
}


// WEBPACK FOOTER //
// ./src/lang/index.js